function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { nextMonth } from '@okee-uikit/react-utils';
import { RangeState } from '../util';
import { BasePanel, PanelType } from './BasePanel';
import { YearPanel } from './YearPanel';
var MONTH_ITEM_COUNT = 3 * 4;
export var MonthPanel = function (_BasePanel) {
  _inherits(MonthPanel, _BasePanel);

  var _super = _createSuper(MonthPanel);

  function MonthPanel(options, parent) {
    var _this;

    _classCallCheck(this, MonthPanel);

    _this = _super.call(this, options, parent);
    _this.currentType = PanelType.MONTH;
    _this.yearIns = new YearPanel(options, _this.owner);
    return _this;
  }

  _createClass(MonthPanel, [{
    key: "getMonthPanelView",
    value: function getMonthPanelView() {
      var monthList = [];
      var year = this.date.getFullYear();
      var startDate = new Date(year, 0, 1);

      for (var i = 0; i < MONTH_ITEM_COUNT; i++) {
        var row = Math.floor(i / 3);
        var col = i % 3;
        var rowList = monthList[row] || [];
        var curDate = nextMonth(startDate, i);
        rowList.push({
          key: +curDate,
          month: i,
          year: year,
          isToday: false,
          gridState: this.getMonthGridState(curDate),
          selectedState: this.getSelectedState(curDate),
          tryingSelectedState: this.getTryingSelectedState(curDate),
          disabledState: this.getDisabledState(curDate)
        });

        if (col === 0) {
          monthList[row] = rowList;
        }
      }

      return {
        year: year,
        monthList: monthList
      };
    }
  }, {
    key: "setCurrentMonth",
    value: function setCurrentMonth(item, virtual) {
      var year = item.year,
          month = item.month,
          disabledState = item.disabledState;

      if (disabledState !== RangeState.NONE) {
        return;
      }

      var newDate = new Date(year, month, 1);

      if (!virtual) {
        this.updateDate(newDate);
        return;
      }

      this.updateDate(newDate, false, true);
    }
  }, {
    key: "getPanelType",
    value: function getPanelType() {
      return PanelType.MONTH;
    }
  }, {
    key: "getDatePanel",
    value: function getDatePanel() {
      throw new Error('date panel is not support');
    }
  }, {
    key: "getMonthPanel",
    value: function getMonthPanel() {
      return this;
    }
  }, {
    key: "getWeekPanel",
    value: function getWeekPanel() {
      throw new Error('week panel is not support');
    }
  }, {
    key: "getYearPanel",
    value: function getYearPanel() {
      return this.yearIns;
    }
  }, {
    key: "syncCurrentDate",
    value: function syncCurrentDate(date) {
      this.setDate(date);
      this.yearIns.setDate(this.date);
    }
  }, {
    key: "getMonthGridState",
    value: function getMonthGridState(date) {
      var month = date.getMonth();

      if (month === 0) {
        return RangeState.START;
      }

      if (month === 11) {
        return RangeState.END;
      }

      return RangeState.IN;
    }
  }]);

  return MonthPanel;
}(BasePanel);